/* ============================================================
   GOOTER — Compare-Banner: Kategorien-Tabs
   ============================================================
   Liest JSON-Daten aus #gcb-cats-data, baut Tab-Rail + Panel.
   Wird mehrfach-safe ausgeführt (mehrere Banner pro Seite OK).
   ============================================================ */

(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-cats]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(data) || data.length === 0) return;

    var rail = root.querySelector('.cat-rail');
    var panel = root.querySelector('.cat-panel');
    if (!rail || !panel) return;

    var factsLabel = panel.getAttribute('data-facts-label') || 'Fakten';

    function renderRail() {
      var html = '';
      data.forEach(function (c, i) {
        var num = String(i + 1).padStart(2, '0');
        html += '<button type="button" role="tab" data-i="' + i + '">'
              +   '<span class="num">' + num + '</span>'
              +   '<span>' + escapeHtml(c.title) + '</span>'
              + '</button>';
      });
      rail.innerHTML = html;
      rail.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-i]');
        if (!btn) return;
        select(parseInt(btn.getAttribute('data-i'), 10));
      });
    }

    function renderPanel(i) {
      var c = data[i];
      if (!c) return;
      panel.innerHTML =
        '<header class="ph">'
      +   '<h3>' + escapeHtml(c.title) + '</h3>'
      +   '<span class="range">' + (c.good || []).length + ' ' + escapeHtml(factsLabel) + '</span>'
      + '</header>'
      + '<p class="pd">' + escapeHtml(c.desc) + '</p>'
      + '<div class="twin twin--single">'
      +   '<div class="side good">'
      +     '<h4>GOOTER E-CadPro</h4>'
      +     '<ul>' + (c.good || []).map(function (t) { return '<li>' + escapeHtml(t) + '</li>'; }).join('') + '</ul>'
      +   '</div>'
      + '</div>';
    }

    function select(i) {
      Array.prototype.forEach.call(rail.querySelectorAll('button'), function (b, bi) {
        if (bi === i) {
          b.classList.add('active');
          b.setAttribute('aria-selected', 'true');
        } else {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        }
      });
      renderPanel(i);
    }

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    renderRail();
    select(0);
  }

  function boot() {
    document.querySelectorAll('.gooter-compare-banner').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
